module.exports = __webpack_public_path__ + "media/images/new_home/green-icon-7f661e2e11273ba89f88c909d0001dfe.png";